var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row margin-tb-150"},[_c('article',{staticClass:"wrap--sm"},[_c('stepper'),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"dusk":"currentView"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }